import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IoCalendarOutline, IoPersonAddOutline, IoReturnDownBack } from "react-icons/io5";
import { createTask } from "../../../Redux/slices/TaskSlice";
import { toast } from 'react-toastify';

const QuickAddTask = () => {
    const dispatch = useDispatch();
    const { conversationId } = useSelector((state) => state.chatUser);
    const [title, setTitle] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!title.trim()) return;

        // Remove the block: if (!conversationId) ...

        setIsSubmitting(true);
        try {
            // "Phase 3: Functionality Fix" - Sanitize payload
            const payload = {
                title: title.trim(),
                description: "",
                dueDate: null, // Future: dueDate ? new Date(dueDate).toISOString() : null
                assignedUserId: null, // Future: assigneeId || null
                conversationId: conversationId?._id || conversationId || null,
                type: (conversationId?._id || conversationId) ? 'CHAT_TASK' : 'PERSONAL'
            };

            console.log('Submitting Task Payload:', payload);

            await dispatch(createTask(payload)).unwrap();
            setTitle('');
            toast.success("Task added");
        } catch (err) {
            console.error("Failed to add task:", err);
            toast.error("Failed to add task");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="px-4 py-2">
            <div className={`relative flex items-center bg-zinc-100 dark:bg-slate-800 rounded-xl transition-all ${isSubmitting ? 'opacity-50' : ''}`}>
                <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Add a task... (Press Enter)"
                    disabled={isSubmitting}
                    className="w-full bg-transparent border-none focus:ring-2 focus:ring-indigo-500 rounded-xl px-4 py-3 text-sm text-gray-800 dark:text-gray-100 placeholder-gray-400 pr-24" // padding right for icons
                />

                {/* Inline Controls */}
                <div className="absolute right-3 flex items-center gap-2 text-gray-400">
                    <button type="button" className="p-1 hover:text-indigo-600 transition-colors" title="Assign (Coming Soon)">
                        <IoPersonAddOutline size={16} />
                    </button>
                    <button type="button" className="p-1 hover:text-indigo-600 transition-colors" title="Due Date (Coming Soon)">
                        <IoCalendarOutline size={16} />
                    </button>
                    <div className="h-4 w-px bg-gray-300 mx-1"></div>
                    <button type="submit" disabled={!title.trim() || isSubmitting} className="p-1 hover:text-indigo-600 transition-colors">
                        <IoReturnDownBack size={16} />
                    </button>
                </div>
            </div>
        </form>
    );
};

export default QuickAddTask;
